import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlCustomerMessage = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      form={props.form}
      label="Single Most Important Message to Leave Customer with"
      name="customerMessage"
      userPermissions={props.userPermissions}
      withAdd
    />
  </BorderedBlock>
);
